// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentVerification-commonHeaderAdmin-maV8S {
	position: fixed !important;
}

.DocumentVerification-adminLayout-VeEPT {
	padding-top: 64px !important;
}

.DocumentVerification-box-dv3rf h2 {
	font-size: 21px;
	font-weight: 600;
}

.DocumentVerification-exportLink-XHdog {
	margin-bottom: -29px;
}

.DocumentVerification-blockCenter-_WNW0 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.DocumentVerification-panelHeader-iutZc {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.DocumentVerification-currencyselect-TjRML {
	width: 100%;
	margin-right: 0px;
}

.DocumentVerification-panelHeader-iutZc {
	overflow: hidden;
	position: relative;
}

.DocumentVerification-mar0-q4q1X {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.DocumentVerification-blockCenter-_WNW0 {
		padding: 0px;
	}

	.DocumentVerification-panelHeader-iutZc {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.DocumentVerification-sideAdminPageWrapper-BlE5G {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.DocumentVerification-panelHeader-iutZc {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.DocumentVerification-table-mLDrI {
	display: table;
}

.DocumentVerification-tableRow-G9WXG {
	display: table-row;
}

.DocumentVerification-tableCell-YCPsF {
	display: table-cell;
	float: none;
}

.DocumentVerification-formGroup-zgTls {
	margin-bottom: 6px;
}

.DocumentVerification-select-fpL5b {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.DocumentVerification-noMargin-IqPP4 {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.DocumentVerification-exportLink-XHdog {
	padding-top: 10px;
	padding-right: 10px;
}

.DocumentVerification-labelTextNew-D_2uJ {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.DocumentVerification-displayInline-NwjOx {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.DocumentVerification-btnUPdate-SmwJJ {
	display: inline-block;
}

.DocumentVerification-btnModalDelete-hSQ4l {
	display: inline-block;
	margin-left: 15px;
}

.DocumentVerification-radioBtn-Y858a {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.DocumentVerification-backgroundImg-MJ9aO {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.DocumentVerification-btnUPdate-SmwJJ {
		display: block;
		margin-bottom: 12px;
	}

	.DocumentVerification-btnModalDelete-hSQ4l {
		display: block;
		margin-left: 0px;
	}

	.DocumentVerification-btnWidth-CHXpr {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.DocumentVerification-bannerImageBg-xLknb {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.DocumentVerification-bannerDelete-luUyd {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.DocumentVerification-modalRoot-F6uG9 {
	padding: 32px;
}

.DocumentVerification-modalBorderBottom-E6mZw {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.DocumentVerification-logInModalBody-VBg37 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.DocumentVerification-exportSection-PUihD {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.DocumentVerification-exportSectionGridSub-AlysU {
	grid-template-columns: 50% 49% !important;
}

.DocumentVerification-exportText-hK3HJ {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.DocumentVerification-exportLinkImg-mvjll {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.DocumentVerification-vtrMiddle-kE5oU {
	vertical-align: middle;
}

.DocumentVerification-exportImg-rOlA9 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.DocumentVerification-profileViewlabel-rHJ1I {
	display: inline-block;
	width: 38%
}

.DocumentVerification-profileViewMainContent-JeOLB {
	display: inline-block;
	width: 62%;
}

.DocumentVerification-profileViewMain-fvY6v {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.DocumentVerification-profileViewInner-BkfX6 {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.DocumentVerification-profileImageSection-ZyJ1F {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.DocumentVerification-lastviewInner-et4Nf {
	padding: 10px;
}

.DocumentVerification-whyHostHoriLine-vliid {
	margin: 30px 0;
}

.DocumentVerification-tableGrid-jp3Bx {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.DocumentVerification-headingContent-RbA5R {
	font-size: 18px;
	font-weight: 500;
}

.DocumentVerification-refundTextColor-Wu_oO {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.DocumentVerification-dividerLine-p2Yw6 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.DocumentVerification-smallContent-iDPMH {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.DocumentVerification-sideAdminPageWrapper-BlE5G {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.DocumentVerification-sideAdminPageWrapper-BlE5G {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.DocumentVerification-exportSection-PUihD {
		grid-template-columns: 100%;
	}

	.DocumentVerification-exportSectionGridSub-AlysU {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.DocumentVerification-profileViewlabel-rHJ1I {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.DocumentVerification-profileViewMainContent-JeOLB {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.DocumentVerification-ChangeToUpperCase-ElYxD {
	text-transform: uppercase
}

.DocumentVerification-noBorder-xzqPU {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.DocumentVerification-siteAdminHeading-nARoo {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.DocumentVerification-siteAdminSubHeading-JptZ5 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.DocumentVerification-adminFormDivider-s7xZv {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.DocumentVerification-selectMargin-d3Qo_ {
    margin: 0px auto;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/DocumentVerification/DocumentVerification.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACrUA;IACI,gBAAgB;AACpB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}","@import '../admin-common.css';\n\n.selectMargin {\n    margin: 0px auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `DocumentVerification-commonHeaderAdmin-maV8S`,
	"adminLayout": `DocumentVerification-adminLayout-VeEPT`,
	"box": `DocumentVerification-box-dv3rf`,
	"exportLink": `DocumentVerification-exportLink-XHdog`,
	"blockCenter": `DocumentVerification-blockCenter-_WNW0`,
	"panelHeader": `DocumentVerification-panelHeader-iutZc`,
	"currencyselect": `DocumentVerification-currencyselect-TjRML`,
	"mar0": `DocumentVerification-mar0-q4q1X`,
	"sideAdminPageWrapper": `DocumentVerification-sideAdminPageWrapper-BlE5G`,
	"table": `DocumentVerification-table-mLDrI`,
	"tableRow": `DocumentVerification-tableRow-G9WXG`,
	"tableCell": `DocumentVerification-tableCell-YCPsF`,
	"formGroup": `DocumentVerification-formGroup-zgTls`,
	"select": `DocumentVerification-select-fpL5b`,
	"noMargin": `DocumentVerification-noMargin-IqPP4`,
	"labelTextNew": `DocumentVerification-labelTextNew-D_2uJ`,
	"displayInline": `DocumentVerification-displayInline-NwjOx`,
	"btnUPdate": `DocumentVerification-btnUPdate-SmwJJ`,
	"btnModalDelete": `DocumentVerification-btnModalDelete-hSQ4l`,
	"radioBtn": `DocumentVerification-radioBtn-Y858a`,
	"backgroundImg": `DocumentVerification-backgroundImg-MJ9aO`,
	"btnWidth": `DocumentVerification-btnWidth-CHXpr`,
	"bannerImageBg": `DocumentVerification-bannerImageBg-xLknb`,
	"bannerDelete": `DocumentVerification-bannerDelete-luUyd`,
	"modalRoot": `DocumentVerification-modalRoot-F6uG9`,
	"modalBorderBottom": `DocumentVerification-modalBorderBottom-E6mZw`,
	"logInModalBody": `DocumentVerification-logInModalBody-VBg37`,
	"exportSection": `DocumentVerification-exportSection-PUihD`,
	"exportSectionGridSub": `DocumentVerification-exportSectionGridSub-AlysU`,
	"exportText": `DocumentVerification-exportText-hK3HJ`,
	"exportLinkImg": `DocumentVerification-exportLinkImg-mvjll`,
	"vtrMiddle": `DocumentVerification-vtrMiddle-kE5oU`,
	"exportImg": `DocumentVerification-exportImg-rOlA9`,
	"profileViewlabel": `DocumentVerification-profileViewlabel-rHJ1I`,
	"profileViewMainContent": `DocumentVerification-profileViewMainContent-JeOLB`,
	"profileViewMain": `DocumentVerification-profileViewMain-fvY6v`,
	"profileViewInner": `DocumentVerification-profileViewInner-BkfX6`,
	"profileImageSection": `DocumentVerification-profileImageSection-ZyJ1F`,
	"lastviewInner": `DocumentVerification-lastviewInner-et4Nf`,
	"whyHostHoriLine": `DocumentVerification-whyHostHoriLine-vliid`,
	"tableGrid": `DocumentVerification-tableGrid-jp3Bx`,
	"headingContent": `DocumentVerification-headingContent-RbA5R`,
	"refundTextColor": `DocumentVerification-refundTextColor-Wu_oO`,
	"dividerLine": `DocumentVerification-dividerLine-p2Yw6`,
	"smallContent": `DocumentVerification-smallContent-iDPMH`,
	"ChangeToUpperCase": `DocumentVerification-ChangeToUpperCase-ElYxD`,
	"noBorder": `DocumentVerification-noBorder-xzqPU`,
	"siteAdminHeading": `DocumentVerification-siteAdminHeading-nARoo`,
	"siteAdminSubHeading": `DocumentVerification-siteAdminSubHeading-JptZ5`,
	"adminFormDivider": `DocumentVerification-adminFormDivider-s7xZv`,
	"selectMargin": `DocumentVerification-selectMargin-d3Qo_`
};
module.exports = ___CSS_LOADER_EXPORT___;
